import React from 'react';

import iconSign from '../../assets/svg/icon-sign.svg';
import iconClinic from '../../assets/svg/icon-clinic.svg';
import iconNeighbor from '../../assets/svg/icon-neighbor.svg';
import iconCheckup from '../../assets/svg/icon-checkup.svg';
import iconOnline from '../../assets/svg/icon-online.svg';
import iconAward from '../../assets/svg/icon-award2.svg';
import iconAward3 from '../../assets/svg/icon-award3.svg';

const reasonsMedicaid = (props) => {
  let headline;
  if (props.headline) {
    headline = <h2>A few reasons why you&rsquo;ll love us.</h2>;
  }

  let medicaid;
  if (props.medicaid) {
    medicaid = (<li className='col'>
      <span><img src={iconAward} alt='' /></span>
      <p>Enjoy peace of mind with New York&rsquo;s #1 Medicaid Plan.*</p>
    </li>);
  }

  let chp;
  if (props.chp) {
    chp = (<li className='col'>
      <span><img src={iconAward3} alt='Top-rated Child Health Plus plan' /></span>
      <p>Enjoy peace of mind with our top-rated Child Health Plus plan!</p>
    </li>
    );
  }

  return (
    <section className={props.classes}>
      <div className='wrap'>
        {headline}
        <ul className='three-col reasons'>
          <li className='col'>
            <span><img src={iconSign} alt='Sign up any time. There’s no open enrollment period' className='sign' /></span>
            <p>Sign up any time. There’s no open enrollment period</p>
          </li>
          <li className='col'>
            <span><img src={iconClinic} alt='Access our quality doctors and community services' /></span>
            <p>Access our quality doctors and community services</p>
          </li>
          <li className='col'>
            <span><img src={iconNeighbor} alt='Talk live with a representative at an Outreach location' /></span>
            <p>Talk live with a representative<br /> at an Outreach location</p>
          </li>
          <li className='col'>
            <span><img src={iconCheckup} alt='Get help booking appointments' /></span>
            <p>Get help booking appointments</p>
          </li>
          <li className='col'>
            <span><img src={iconOnline} alt='Ability to see a doctor online' /></span>
            <p>Ability to see a doctor online<br /> from the comfort of home</p>
          </li>
          {medicaid}
          {chp}
        </ul>
      </div>
    </section>
  );
};

export default reasonsMedicaid;



// WEBPACK FOOTER //
// ./src/components/Reasons/ReasonsMedicaid.js